import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, CheckCircle2, FileCheck, Receipt, Truck, Users, Wallet } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const blocks = [
  { key: 'customers', icon: Users },
  { key: 'suppliers', icon: Truck },
  { key: 'checks', icon: FileCheck },
  { key: 'employees', icon: Wallet },
  { key: 'expenses', icon: Receipt },
  { key: 'alerts', icon: Bell },
];

export default function FeaturesPage() {
  const { t } = useLanguage();

  return (
    <section className="section page-top">
      <div className="container">
        <div className="section-head">
          <h1>{t.featuresPage.title}</h1>
          <p>{t.featuresPage.subtitle}</p>
        </div>

        <div className="detail-grid">
          {blocks.map(({ key, icon: Icon }) => {
            const item = t.featureDetails[key];
            return (
              <article key={key} className="detail-card">
                <div className="detail-head">
                  <div className="feature-icon solid">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h2>{item.title}</h2>
                  </div>
                </div>
                <ul>
                  {item.points.map((point) => (
                    <li key={point}>
                      <CheckCircle2 size={16} />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <div className="page-cta">
          <Link to="/demo" className="btn btn-primary btn-lg">
            {t.nav.demo}
          </Link>
        </div>
      </div>
    </section>
  );
}
